<template>
  <v-row justify="center">
    <v-col cols="12" sm="10" md="8" lg="6">
      <v-card ref="form" class="my-15 pa-2 pa-sm-4">
        <v-card-title><h1 class="mt-3 mb-5">Login</h1></v-card-title>
        <v-card-text>
          <v-text-field
            ref="email"
            v-model="email"
            :rules="[
              v => !!v || 'E-mail is required',
              v => /.+@.+/.test(v) || 'E-mail must be valid',
              addressCheck
            ]"
            label="Email"
            placeholder="test@email.com"
            filled
            required
          ></v-text-field>
          <v-text-field
            ref="password"
            v-model="password"
            type="password"
            :rules="[
              () => !!password || 'This field is required',
              addressCheck
            ]"
            label="password"
            filled
            required
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-slide-x-reverse-transition>
            <v-tooltip v-if="formHasErrors" left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  class="my-0"
                  v-bind="attrs"
                  @click="resetForm"
                  v-on="on"
                >
                  <v-icon>mdi-refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh form</span>
            </v-tooltip>
          </v-slide-x-reverse-transition>
          <v-btn color="primary" @click="submit" :loading="loading">
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import axios from "axios";
export default {
  name: "Login",
  data: () => ({
    layout: "",
    errorMessages: "",
    password: null,
    email: null,
    formHasErrors: false,
    loading: false
  }),

  computed: {
    form() {
      return {
        email: this.email,
        password: this.password
      };
    }
  },

  watch: {
    name() {
      this.errorMessages = "";
    }
  },

  methods: {
    addressCheck() {
      this.errorMessages =
        this.address && !this.name ? `Hey! I'm required` : "";
      return true;
    },
    resetForm() {
      this.errorMessages = [];
      this.formHasErrors = false;

      Object.keys(this.form).forEach(f => {
        this.$refs[f].reset();
      });
    },
    async submit() {
      this.formHasErrors = false;
      Object.keys(this.form).forEach(f => {
        if (!this.form[f]) this.formHasErrors = true;
        this.$refs[f].validate(true);
      });
      if (!this.formHasErrors) {
        this.loading = true;
        delete axios.defaults.headers.common.Authorization;
        try {
          const loginUrl = `${process.env.VUE_APP_BASE_URL}/auth/local`;
          const loginResponse = await axios.post(loginUrl, {
            identifier: this.email,
            password: this.password
          });
          console.log(loginResponse);
          const AuthToken = `Bearer ${loginResponse.data.jwt}`;
          localStorage.setItem("AuthToken", AuthToken);
          axios.defaults.headers.common.Authorization = AuthToken;
          const welcomeMsg = `Login Successful, welcome ${loginResponse.data.user.username}`;
          this.$toast.success(welcomeMsg);
          this.$router.push({ path: "/" });
        } catch (error) {
          if (error.response) {
            const errorMsg = `${error.response.data.message[0].messages[0].message}`;
            this.$toast.error(errorMsg);
          } else {
            this.$toast.error("Something went wrong, please try again");
          }
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style></style>
